import styles from "./styles/NotificationLayout.module.css";
import { NotificationHeader } from "./NotificationHeader";
import { NotificationFooter } from "./NotificationFooter";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const NotificationLayout = () => {
  return (
    <div className={styles.container}>
      <ToastContainer className={styles.toastContainer} />
      <div className={styles.background} />
      <div className={styles.subContainer}>
        <NotificationHeader />
        <div className={styles.body}>
          <Outlet />
        </div>
        <NotificationFooter />
      </div>
    </div>
  );
};

/* required: display name */
NotificationLayout.displayName = "NotificationLayout";

/* required: props types */
NotificationLayout.propTypes = {};

/* required: default props */
NotificationLayout.defaultProps = {};

export { NotificationLayout };
